import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterSection = () => {
  const { t, language } = useLanguage();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, {
        email,
        language,
      });
      setIsSubscribed(true);
      toast.success(t('newsletter.success'));
      setEmail('');
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error('Email déjà inscrit');
      } else {
        toast.error(t('newsletter.error'));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section
      data-testid="newsletter-section"
      className="py-24 md:py-32 bg-gradient-to-br from-oar-green to-oar-green-dark relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2
            data-testid="newsletter-title"
            className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-white mb-4"
          >
            {t('newsletter.title')}
          </h2>
          <p className="text-base text-white/80 mb-8">
            {t('newsletter.description')}
          </p>

          {isSubscribed ? (
            <div className="flex items-center justify-center gap-3 text-white">
              <CheckCircle className="w-6 h-6" />
              <span className="text-lg">{t('newsletter.success')}</span>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('newsletter.placeholder')}
                data-testid="newsletter-email-input"
                className="flex-1 bg-white/10 border border-white/30 focus:border-white text-white placeholder:text-white/60 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-white/50 transition-colors"
                required
              />
              <button
                type="submit"
                disabled={isLoading}
                data-testid="newsletter-submit-btn"
                className="flex items-center justify-center gap-2 bg-oar-orange hover:bg-oar-orange-dark disabled:opacity-50 text-white rounded-lg px-6 py-3 font-medium transition-all duration-300 shadow-lg"
              >
                {isLoading ? (
                  <span className="animate-spin">⏳</span>
                ) : (
                  <>
                    <Send className="w-4 h-4" />
                    {t('newsletter.button')}
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
